import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { ArrowForward } from '@mui/icons-material';

const GetStartedSection = ({ content }) => {
  return (
    <Container className="p-2 p-md-5 mt-4 hero-section">
      <Row className="hero-content">
        <Col>
          <p
            className="text-center text-lg px-md-5"
            style={{ lineHeight: '42px' }}>
            {content.title}
          </p>
        </Col>
      </Row>
      <Row className="p-md-4 align-items-center hero-content">
        <Col>
          <h4 className="text-center" style={{ fontSize: 16 }}>
            {content.subtitle}
          </h4>
          <Container className="px-5">
            <Row>
              <Col>
                <p className="text-left p-md-5 pt-md-3 pb-0 text-std">
                  {content.description}
                </p>
                <ul className="list-unstyled ms-0 ps-0 text-left text-std">
                  {content.points?.map((point, index) => (
                    <li key={index} className="mb-3">
                      {point}
                    </li>
                  ))}
                </ul>
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>

      <Row className="pb-4 mt-2 hero-content">
        <Col className="text-center">
          {content.showButton && (
            <>
              <p className="text-std">
                Discover how GAINSS turns testing into a strategic advantage
                with built-in AI
              </p>
              <a
                href="https://app.gainss.ai/register"
                style={{ background: 'white', marginRight: '20px' }}
                className="demo btn-rounded text-blue mt-4 mt-md-0 btn btn-primary">
                Try For Free <ArrowForward />
              </a>
            </>
          )}
          <a
            href="https://calendly.com/vikas-mittal"
            target="_blank"
            rel="noreferrer"
            style={{
              borderColor: 'white',
              color: 'white',
              border: '1px solid',
              minHeight: '40px',
            }}
            className="new-btn btn btn-rounded btn-transaprent ml-md-4 mt-4 mt-md-0">
            Get a Demo <ArrowForward />
          </a>
        </Col>
      </Row>
    </Container>
  );
};

export default GetStartedSection;
